import Loadable from '@townsquare/loadable';
import { dashboardRoute } from '@townsquare/routes/dashboard';
import { dashboardByIdRoute } from '@townsquare/routes/dashboard-by-id';
import { dashboardDirectoryRoute } from '@townsquare/routes/dashboard-directory';

const DashboardDirectory = Loadable({
	loader: () =>
		import(/* webpackChunkName: "dashboard-directory-view" */ './components/DashboardDirectory'),
	loading: () => null,
});
dashboardDirectoryRoute.component = DashboardDirectory;
export const dashboardDirectoryRouterRoute = dashboardDirectoryRoute;

const Dashboard = Loadable({
	loader: () => import(/* webpackChunkName: "dashboard-view" */ './components/Dashboard'),
	loading: () => null,
});
dashboardRoute.component = Dashboard;
export const dashboardRouterRoute = dashboardRoute;

dashboardByIdRoute.component = Dashboard;
export const dashboardByIdRouterRoute = dashboardByIdRoute;
